import { Loader2 } from "lucide-react";

export const LoadingState = ({ testId = "loading-state" }) => (
  <div
    className="flex flex-col items-center justify-center py-16 text-slate-400"
    data-testid={testId}
  >
    <Loader2 className="w-6 h-6 animate-spin mb-3" />
    <div className="text-xs tracking-wide uppercase">Consultando Odoo...</div>
  </div>
);

export const ErrorState = ({ message, testId = "error-state" }) => (
  <div
    className="border border-red-200 bg-red-50 rounded-md p-4 text-sm text-red-700"
    data-testid={testId}
  >
    <div className="font-semibold mb-1">Error</div>
    <div>{message}</div>
  </div>
);
